import React from 'react';
import { withFormik } from 'formik';
import Select from 'react-select';
import { defaultTo } from 'ramda';

import { routes } from '../../routes';
import { apiRegister } from '../../api/user';
import { handleError } from '../../util/forms';

import Card from '../../components/Card';
import EditField from '../../components/Forms/EditField';

const Register = ({
  errors,
  touched,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  isSubmitting,
  isValid,
  status,
}) => (
  <div className="col-md-8">
    <Card>
      <Card.Header>Create Account</Card.Header>
      <Card.Body>
        <form>
          <EditField
            name="firstName"
            label="First Name"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.firstName}
          />
          <EditField
            name="middleName"
            label="Middle Name"
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.middleName}
          />
          <EditField
            name="lastName"
            label="Last Name"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.lastName}
          />
          <EditField
            name="email"
            label="E-Mail Address"
            type="email"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          <EditField
            name="password"
            label="Password"
            type="password"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
          <EditField
            name="passwordConfirmation"
            label="Confirm Password"
            type="password"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.passwordConfirmation}
          />
          <EditField
            as={Select}
            bare
            simpleValue
            label="How did you hear about us?"
            name="referral"
            status={status}
            onChange={(value) => setFieldValue('referral', value)}
            onBlur={handleBlur}
            value={values.referral}
            options={[
              { value: 'internet', label: 'Internet' },
              { value: 'colleague_friend', label: 'Colleague / Friend' },
              { value: 'employment', label: 'Employment' },
              { value: 'exhibition_conference', label: 'Exhibition / Conference' },
              { value: 'social_media', label: 'Social Media' },
              { value: 'other', label: 'Other' },
            ]}
          />
          {values.referral == 'other' && (
            <EditField
              name="referralOther"
              label="If Other, Please Specify"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.referralOther}
            />
          )}
          <div className="form-group row mb-0">
            <div className="col-md-9 offset-md-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isValid || isSubmitting}
                onClick={handleSubmit}
              >
                Create Account
              </button>
            </div>
          </div>
        </form>
      </Card.Body>
    </Card>
  </div>
);

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const referral = payload.referral == 'other' ? payload.referralOther : payload.referral;
    let referrer;
    try {
      referrer = localStorage.getItem('referrer');
    } catch (err) {
      console.log(err);
    }
    const redirect = defaultTo(routes.dashboard, referrer);

    apiRegister({ ...payload, referral })
      .then(() => (window.location.href = redirect))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: () => ({
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    referral: '',
    referralOther: '',
  }),
  isInitialValid: true,
  validateOnChange: true,
})(Register);
